import script from "./LearningTrails.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningTrails.vue?vue&type=script&setup=true&lang=js"

import "./LearningTrails.vue?vue&type=style&index=0&id=121ae8e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121ae8e0"]])

export default __exports__